import { cn } from '@restworld/utils-common';

// Same containers as the discard flow (discard-candidate/use-discard-candidate.tsx), copied rather than
// exported so the discard flow stays untouched.

export const BodyWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('max-w-screen-sm mx-auto px-4 py-6 text-left md:py-10 md:px-12', className)} {...props} />
);

export const Header = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('mb-8 text-center', className)} {...props} />
);

export const Title = ({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h2 className={cn('text-xl lg:text-2xl font-semibold text-neutral-700 mb-2', className)} {...props} />
);

export const Subtitle = ({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('text-base text-neutral-200 leading-relaxed', className)} {...props} />
);

// Mirrors the default candidate-modal footer container so the modal stays visually aligned across
// variants. BaseModal is mounted with `noPadding` from the candidate-modal, so the vertical padding
// is added here.
export const FooterRow = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'flex flex-col-reverse items-stretch justify-between w-full gap-3 px-4 py-3 lg:flex-row lg:items-center lg:px-10 lg:py-4',
      className
    )}
    {...props}
  />
);
